import { InputProps } from '@mui/material';
import { UseFiltersColumnProps } from 'react-table';

import { FilterInput } from './styledComponents';

type FilterBasicProps<
  T extends Record<string, unknown> = Record<string, unknown>,
> = {
  column: UseFiltersColumnProps<T>;
} & InputProps;
export const FilterBasic = <
  T extends Record<string, unknown> = Record<string, unknown>,
>(
  props: FilterBasicProps<T>,
) => {
  const { filterValue, setFilter } = props.column;
  return (
    <FilterInput
      value={filterValue || ''}
      onChange={({ target: { value } }) => {
        setFilter(value || undefined); // Set undefined to remove the filter entirely
      }}
    />
  );
};
